export interface GuestTokenPayload {
    token: string;
    email: string;
}

export class GuestTokenRequestError extends Error {
    status: number;
    responseBody: string;

    constructor(status: number, responseBody: string) {
        super(`generate-token failed with status ${status}`);
        this.name = 'GuestTokenRequestError';
        this.status = status;
        this.responseBody = responseBody;
    }
}

export interface GuestLinkContext {
    benefitType: string;
    party: string;
    claimId: string;
}

export async function validateLink(code: string, context?: GuestLinkContext): Promise<number> {
    const response = await fetch(`${process.env.REACT_APP_FORMS_SERVICE_URL}/validate-link`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ authenticationCookie: code, ...context })
    });
    return response.status;
}

export async function generateToken(magicLinkCode?: string): Promise<GuestTokenPayload> {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (magicLinkCode) {
        headers['x-link-validation'] = magicLinkCode;
    }

    const response = await fetch(`${process.env.REACT_APP_FORMS_SERVICE_URL}/generate-token`, {
        method: 'POST',
        headers,
        credentials: 'include'
    });
    if (!response.ok) {
        throw new GuestTokenRequestError(response.status, await response.text());
    }
    return response.json();
}

export async function sessionLogout(token: string): Promise<void> {
    await fetch(`${process.env.REACT_APP_FORMS_SERVICE_URL}/session-logout`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        credentials: 'include'
    });
}
